<template>
    <section class="testimonial section">
        <h2 class="section__title">Testimonial</h2>
        <span class="section__subtitle">My Client saying</span>

        <div class="testimonial__container container swiper">
            <div class="swiper-wrapper">
                <!--==================== TESTIMONIAL ITEMS ====================-->
                <div v-for="item in testimonialItems" :key="item.id" class="testimonial__content swiper-slide">
                    <div class="testimonial__data">
                        <div class="testimonial__header">
                            <img :src="item.image" class="testimonial__img" alt="">

                            <div>
                                <h3 class="testimonial__name">{{ item.name }}</h3>
                                <span class="testimonial__client">{{ item.role }}</span>
                            </div>
                        </div>

                        <div class="testimonial__stars">
                            <i v-for="star in item.rating" :key="star" class="bx bxs-star testimonial__icon-star"></i>
                        </div>
                    </div>

                    <p class="testimonial__description">{{ item.description }}</p>
                </div>
            </div>
            <div class="swiper-pagination swiper-pagination-testimonial"></div>
        </div>
    </section>
</template>

<script>
import { testimonialData } from '@/data/testimonials.js';

export default {
    name: 'Testimonial',
    data() {
        return {
            testimonialItems: testimonialData
        };
    }
}
</script>
